// authSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiRequest } from '../_helpers/apiConfig';
import { toast } from "react-toastify";

// export const adminLogin = createAsyncThunk("auth/adminLogin", async (credentials) => {
//   const response = await apiRequest('POST', '/v1/admin/login', credentials);

//   console.log('responce--->',response)
//   return response; 
// });

export const adminLogin = createAsyncThunk("auth/adminLogin", async (credentials, { rejectWithValue }) => {
  try {
    let rememberMe = credentials.rememberMe;
    delete credentials.rememberMe;
    const response = await apiRequest('POST', '/v1/admin/login', credentials);

    if (!response.data || !response.data.token) {
      toast(response.message||'Invalid credentials');

      throw new Error(response.message || 'Invalid credentials');
    }
    if (rememberMe === "yes") {
      localStorage.setItem('accessToken1', response.data.token);
      localStorage.setItem('adminId1', response.data.userId);
    }
    return response;
  } catch (error) {

    return rejectWithValue(error.response?.data?.message || error.message || 'Login failed');
  }
});

export const categoryManagement = createAsyncThunk("category/getCategoryListAdmin", async (filters) => {
  const response = await apiRequest('POST', '/v1/category/getCategoryListAdmin', filters);
  return response;
});




const authSlice = createSlice({
  name: 'auth',
  initialState: {
    category: [],
    total: null,
    loading: false,
    error: null,

  },
  reducers: {
    logout(state) {
      state.user = null;
      state.error = null;
      localStorage.removeItem('accessToken');
      localStorage.removeItem('adminId1');
      localStorage.removeItem('adminId');

      // localStorage.clear()
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(adminLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(adminLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        localStorage.setItem("adminData", JSON.stringify(action.payload.data));
        localStorage.setItem('accessToken', action.payload.data.token);
        localStorage.setItem('adminId', action.payload.data.userId);
        toast.info(action?.payload?.message || "Login Successfully")
      })
      .addCase(adminLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload || "Login Failed!";
      })

      .addCase(categoryManagement.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(categoryManagement.fulfilled, (state, action) => {
        state.loading = false;
        state.category = action.payload.data.list;
        state.total = action.payload.data.total;
      })
      .addCase(categoryManagement.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });

  },
});

// Export the actions and reducer
export const { logout } = authSlice.actions;
export default authSlice.reducer;
